module.exports = __webpack_public_path__ + "img/medium.9327e0ac.svg";